export default {
  'zh-CN': {
    userAgreement: {
      title: '用户服务协议',
      updated: '最后更新：2026-01-20',
      intro: '欢迎使用 Fuzozo。使用本应用即表示您同意以下条款。',
      sections: [
        { title: '1. 应用使用', paragraphs: ['您仅可将本应用用于个人且合法的用途。', '您同意不会滥用本应用，也不会尝试干扰其正常运行。'] },
        { title: '2. 账号', paragraphs: ['您有责任妥善维护账号安全。', '您可以随时在应用内退出登录或删除账号。'] },
        { title: '3. 账号终止', paragraphs: ['对于违反本协议的账号，我们保留暂停或终止服务的权利。'] },
        { title: '4. 免责声明', paragraphs: ['本应用按“现状”提供，不附带任何形式的保证。', '我们不保证服务不会中断或完全无错误。'] },
        { title: '5. 条款变更', paragraphs: ['我们可能会不时更新本协议。', '继续使用本应用即表示您接受更新后的条款。'] },
        { title: '6. 联系我们', paragraphs: ['如有任何问题，请联系：', 'support{\'@\'}fuzozo.net'], email: 'support{\'@\'}fuzozo.net' }
      ]
    }
  },
  en: {
    userAgreement: {
      title: 'User Service Agreement',
      updated: 'Last updated: 2026-01-20',
      intro: 'Welcome to Fuzozo. By using this application, you agree to the following terms.',
      sections: [
        { title: '1. Use of the App', paragraphs: ['You may use the app for personal and lawful purposes only.', 'You agree not to misuse the app or attempt to disrupt its operation.'] },
        { title: '2. Account', paragraphs: ['You are responsible for maintaining the security of your account.', 'You may log out or delete your account at any time within the app.'] },
        { title: '3. Account Termination', paragraphs: ['We reserve the right to suspend or terminate accounts that violate these terms.'] },
        { title: '4. Disclaimer', paragraphs: ['The app is provided "as is" without warranties of any kind.', 'We do not guarantee uninterrupted or error-free service.'] },
        { title: '5. Changes to These Terms', paragraphs: ['We may update these terms from time to time.', 'Continued use of the app means you accept the updated terms.'] },
        { title: '6. Contact Us', paragraphs: ['If you have any questions, please contact us at:', 'support{\'@\'}fuzozo.net'], email: 'support{\'@\'}fuzozo.net' }
      ]
    }
  },
  ja: {
    userAgreement: {
      title: 'Fuzozoフゾゾ 利用規約',
      updated: '最終更新日：2026年8月5日',
      version: 'バージョン：1.4',
      intro: '本利用規約（以下「本規約」といいます。）は、株式会社Fuzozo（以下「当社」といいます。）が提供するAI技術を利用したコミュニケーションロボット「Fuzozo（フゾゾ）」（以下「本製品」といいます。）に関連するアプリケーション、ソフトウェア、オンラインサービスその他一切の関連サービス（以下総称して「本サービス」といいます。）の利用条件を定めるものです。ユーザーは、本サービスの利用を開始する前に本規約を確認し、これに同意するものとします。',
      sections: [
        {
          title: '第1条（適用）',
          paragraphs: [
            '１　本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。',
            '２　当社は、本サービスに関し、本規約のほか、ガイドライン、ポリシー、注意事項その他の個別規定（以下「個別規定」といいます。）を定める場合があります。',
            '３　個別規定は、本規約の一部を構成します。',
            '４　本規約と個別規定の内容が異なる場合、個別規定は、その対象となるサービスまたは事項についてのみ優先して適用され、その他の事項には本規約が適用されます。',
            '５　本製品（ハードウェア）の売買契約ならびに本製品の品質、契約不適合責任、製品保証、返品および交換については、本規約とは別に、当社または販売事業者が定める販売条件および製品保証規定に従います。'
          ]
        },
        {
          title: '第2条（利用登録およびアカウント管理）',
          paragraphs: [
            '１　本サービスの利用を希望する者は、当社の定める方法により利用登録を行うものとします。',
            '２　ユーザーは、自己の責任において、アカウント情報、認証情報その他ログインに必要な情報を適切に管理し、これを第三者に使用させ、または譲渡、貸与、売買その他の処分をしてはならないものとします。ただし、第3条第2項に従い15歳未満の方に利用させる場合および第5項に従い同一世帯内の者に本製品を使用させる場合は、この限りではありません。',
            '３　アカウントの管理不十分、使用上の過誤または第三者による不正使用等によってユーザーに損害が生じた場合、当社の責めに帰すべき事由がない限り、当社は責任を負いません。当社が責任を負う場合、その範囲は第11条の定めによります。',
            '４　ユーザーは、当社の責めに帰すべき事由による場合を除き、自己のアカウントを通じて行われた行為について責任を負うものとします。',
            '５　ユーザーは、自己の責任および管理の下で、同居する家族その他ユーザーと同一の世帯に属する者に本製品を使用させることができます。この場合、ユーザーは、当該使用者が本規約およびプライバシーポリシーの内容をあらかじめ確認できるようにするものとし、当該使用者による本製品の使用について、自己の行為と同様に本規約に基づく責任を負うものとします。'
          ]
        },
        {
          title: '第3条（利用対象年齢および未成年者の利用）',
          paragraphs: [
            '１　本製品および本サービスは、15歳以上の方による単独利用を主な対象とします。',
            '２　15歳未満の方は、親権者その他の法定代理人が、当該15歳未満の方の年齢、理解力および心身の発達状況に照らして本製品および本サービスの利用が適切であると判断し、本規約に同意し、プライバシーポリシーの内容を確認して当社が求める必要な同意を行った上で、取扱説明書その他当社が表示する安全上または使用上の注意事項に従い、当該法定代理人の責任および監督の下で本製品および本サービスを利用することができます。この場合、利用登録および有料サービスの購入は当該法定代理人が行い、当該法定代理人を本規約上のユーザーとして、15歳未満の方による利用を管理し、本規約を遵守させるものとします。',
            '３　15歳以上18歳未満のユーザーが本製品もしくは本サービスを利用し、または有料サービスを購入する場合には、親権者その他の法定代理人が、本規約およびプライバシーポリシーの内容を確認した上で、あらかじめ当該利用または購入について同意するものとします。',
            '４　当社は、必要に応じて、ユーザーに対し、年齢、法定代理人であること、法定代理人の同意の有無その他当社が必要と判断する事項について、合理的な方法による確認を求めることができます。',
            '５　ユーザーが前項の事項について虚偽の申告をした場合、当社は、第9条の定めによるほか、本サービスの利用停止、利用登録の取消しその他必要な措置を講じることができます。ただし、未成年者が行った法律行為の取消しその他の法的効果については、法令の定めに従うものとします。'
          ]
        },
        {
          title: '第4条（利用許諾および知的財産権）',
          paragraphs: [
            '１　本サービスに関する一切の知的財産権（プログラム、ソフトウェア、仕様、デザイン、画像、文章、商標、ロゴその他一切を含みますが、これらに限られません。）は、当社または正当な権利を有する第三者に帰属します。',
            '２　当社は、ユーザーに対し、本規約および個別規定に従うことを条件として、本サービスを私的な目的のために、非独占的、譲渡不能かつ再許諾不能の範囲で利用する権利を許諾します。',
            '３　前項の利用許諾は、本サービスの提供期間中に限り有効であり、本サービスの利用が終了した場合には終了します。',
            '４　前2項は知的財産権の譲渡を意味するものではありません。ユーザーは、本サービスの利用にあたり、当社または第三者の知的財産権を侵害してはならないものとします。',
            '５　第2項にかかわらず、当社は、ユーザーに対し、本サービスの提供期間中、第6条第1項第11号ただし書に定める範囲で、本製品もしくは本サービスの通常の利用状況またはAI出力を、SNSその他の媒体に投稿し、または紹介するために必要な範囲で利用する非独占的かつ譲渡不能の権利を許諾します。ユーザーは、投稿先媒体の利用条件上必要となる範囲で、当該媒体の運営者その他当該利用条件に基づき利用許諾を受ける者に対し、当該投稿について必要な利用許諾（再許諾または譲渡が可能な利用許諾を含みます。）を行うことができます。本項に基づき本サービスの利用終了前に適法に行われた投稿および当該投稿について付与された利用許諾は、当該媒体の利用条件に従い、本サービスの利用終了後も存続します。'
          ]
        },
        {
          title: '第5条（ユーザーコンテンツの取扱い）',
          paragraphs: [
            '１　ユーザーが本サービスに入力、送信または投稿したテキスト、画像、音声その他の情報（以下「ユーザーコンテンツ」といいます。）に関する権利は、当該ユーザーまたは正当な権利者に留保されます。',
            '２　ユーザーは、当社に対し、本サービスの提供、運営、維持、改善、不具合対応、品質管理、安全対策、カスタマーサポートその他これらに付随する目的のために必要な範囲で、当社が自らまたは本サービスの提供に必要な委託先（国外に所在する者を含みます。）を通じて、ユーザーコンテンツを無償で利用（複製、保存、表示、解析、翻案その他必要な利用を含みます。）することを許諾するものとします。',
            '３　ユーザーは、前項に定める利用のうち、本サービスの提供上必要な範囲で行われる編集、翻案、表示形式の変更その他の技術的処理について、当社に対して著作者人格権を行使しないものとします。',
            '４　当社による個人情報、ユーザーコンテンツその他のデータの取扱いについては、プライバシーポリシーその他当社が別途表示する内容および法令に従います。',
            '５　ユーザーが当社に提供した本サービスに関する意見、提案、要望その他のフィードバックについて、当社との間で別途合意がある場合を除き、ユーザーは、当社が本サービスの開発、改善その他の事業活動のために無償で利用することを許諾します。当社は、当該フィードバックの採用、実現または個別の回答を約束するものではありません。'
          ]
        },
        {
          title: '第6条（禁止事項）',
          paragraphs: [
            '１　ユーザーは、本サービスの利用にあたり、次の各号に掲げる行為を行ってはなりません。',
            '（１）法令、公序良俗または本規約もしくは個別規定に違反する行為',
            '（２）犯罪行為に関連する行為、またはこれを助長し、誘引し、もしくは予告する行為',
            '（３）過度に暴力的、残虐、性的、差別的または嫌悪を助長する表現を送信または生成させる行為',
            '（４）自傷行為、他害行為、違法行為その他危険な行為を助長する目的で本サービスを利用する行為',
            '（５）他者になりすます行為、または虚偽の情報を登録もしくは送信する行為',
            '（６）他のユーザーまたは第三者に対する嫌がらせ、誹謗中傷、脅迫、ストーキングその他これらに類する行為',
            '（７）第三者の個人情報、機密情報または秘密情報を、正当な権限なく入力、送信または投稿する行為（ただし、本製品の通常の家庭内利用に伴い、同居する家族その他その場に居合わせた者の発話その他の情報が取得される場合を除きます。）',
            '（８）本サービスまたはこれに関連するシステム、ネットワークもしくはサーバー等に過度な負荷をかける行為',
            '（９）本サービスの運営を妨害する行為、または当社のシステムもしくはセキュリティを侵害し、回避し、もしくは無効化しようとする行為',
            '（１０）本サービスの逆コンパイル、逆アセンブル、リバースエンジニアリングその他これらに類する行為',
            '（１１）当社の事前の承諾なく、本サービスを、第三者への販売、再販売、貸与もしくは提供、第三者に対する商品もしくは役務の提供、または宣伝、広告、勧誘、営業その他の営利事業のために利用する行為。ただし、ユーザーが、本製品もしくは本サービスの通常の利用状況またはAI出力を、そのまままたは通常の編集を加えて、法令および投稿先媒体の利用条件に従い必要な表示を行い、第三者の権利を侵害せず、かつ、当社が当該投稿を作成、承認もしくは推奨したこと、または当社との間に提携、協賛、公認その他の特別な関係があることについて誤認を生じさせない態様で、SNSその他の媒体に投稿し、または紹介する行為は、この限りではありません。当該媒体が一般の投稿者に提供する通常の収益化機能により、広告収益その他これに類する付随的な収益を得る場合も、同様とします。',
            '（１２）反社会的勢力への利益供与その他これに協力する行為',
            '（１３）その他、当社が不適切と合理的に判断する行為'
          ]
        },
        {
          title: '第7条（AIサービスに関する注意事項）',
          paragraphs: [
            '１　本サービスはAIを利用した対話型サービスであり、その回答、提案、表現、会話から生成される記憶、日記その他の出力内容（以下「AI出力」といいます。）には、事実と異なる、不正確、不完全、不適切またはユーザーの意図に沿わない内容が含まれる場合があります。',
            '２　当社は、AI出力の正確性、完全性、有用性、特定の目的への適合性、継続性または安全性について保証するものではありません。',
            '３　本サービスは、医療行為、診断、治療、心理療法、法律相談、投資助言その他の専門的判断を代替するものではなく、保育、介護、安否確認、見守り、緊急通報その他ユーザーまたは第三者の生命もしくは身体の安全を確保するための手段として利用することはできません。ユーザーは、必要に応じて適切な専門家または関係機関に相談するものとします。',
            '４　ユーザーは、AI出力を自己の責任において利用するものとし、その利用にあたっては自ら確認および判断を行うものとします。',
            '５　当社は、不正利用の防止、法令遵守、セキュリティその他本サービスの運営上必要と合理的に判断した場合、特定の入力もしくは出力を制限し、表示を変更し、または本サービスの全部もしくは一部の利用を停止することがあります。',
            '６　当社は、本サービスの提供にあたり、外部のAIサービスその他第三者が提供する技術またはサービスを利用する場合があります。この場合、ユーザーが本サービスに入力、送信または発話した情報の一部または全部が、本サービスの提供に必要な範囲で当該提供者に送信されることがあります。送信先、目的その他の取扱いの詳細については、プライバシーポリシーその他当社が別途表示する内容をご確認ください。',
            '７　外部のAIサービスその他第三者が提供するサービスの停止、変更、障害その他当社の合理的な支配の及ばない事由により、本サービスの全部または一部を利用できない場合があります。これに関する当社の責任は、第11条の定めによります。',
            '８　ユーザーによるAI出力の利用については、第4条および第6条第1項第11号の定めによります。当社は、第5条第2項に定める目的のために必要な範囲でAI出力を利用することができ、その取扱いについては同条第4項の定めによります。'
          ]
        },
        {
          title: '第8条（通信環境、料金および有料サービス）',
          paragraphs: [
            '１　本サービスの利用には、インターネット接続環境が必要です。本サービスの利用に必要な端末、通信環境、ソフトウェアおよび通信料金は、当社が別途明示して提供するものを除き、ユーザーの責任と負担とします。',
            '２　本サービスの全部または一部は、通信回線、クラウドサービス、決済サービスその他第三者が提供するサービスに依存します。通信状況、混雑、保守、障害、仕様変更、提供終了その他の事情により、本サービスの全部または一部が一時的に利用できず、またはその品質が変動する場合があります。',
            '３　当社が本製品の内蔵SIMを用いた4G LTEによる通信機能を提供する場合、当該通信機能は、本サービスのデータ通信専用であり、音声通話、SMSまたは緊急通報には利用できません。その提供条件は、当社が別途表示する条件または個別規定によります。',
            '４　当社は、本サービスについて、無料もしくは有料のプラン、サブスクリプション、アプリ内課金その他の利用条件（以下、有料のものを「有料サービス」といいます。）を設定することがあります。',
            '５　各プランおよび有料サービスの内容、機能、利用上限、料金、利用期間、支払方法、自動更新の有無および条件、解約条件その他の詳細は、アプリ内、購入手続画面、個別規定または特定商取引法に基づく表示等において、申込み前に表示する条件によります。',
            '６　キャンペーン、本製品とのセット販売、コードその他の方法により付与される利用権の内容、有効期間その他の条件は、付与時または申込み時に表示された条件によります。',
            '７　App Store、Google Playその他の第三者プラットフォームを通じて購入する場合、法令に反しない範囲で、決済、更新、解約および返金等について当該プラットフォームの条件および手続が適用される場合があります。',
            '８　自動更新型の有料サービスは、ユーザーが購入時に表示された期限までに所定の方法で自動更新を停止しない限り、表示された条件に従って更新され、更新後の料金が請求されます。料金または条件の変更は、法令に従い必要な表示または周知を行ったうえで、変更後の更新または新たな購入から適用されます。',
            '９　購入手続完了後は、法令上認められる場合または当社が別途認める場合を除き、ユーザーの都合による返金、取消し、交換または他のサービスへの振替は行いません。自動更新の停止は、別途表示がある場合を除き、次回以降の更新を停止するものであり、既に支払われた料金の日割り返金は行いません。',
            '１０　有料サービスその他本サービスに関する利用権は、当該ユーザー本人のアカウントにのみ付与され、第三者に移転、共有、貸与、譲渡、売買その他の処分をすることはできません。ただし、第2条第5項に従い、ユーザーの責任および管理の下で同一世帯内において本製品を共用することを妨げません。',
            '１１　ユーザーは、不正な手段、システム上の不具合、バグ、チートツール、ボット、クローラ、スクレイピングその他不正な技術的手段を利用して、有料サービスもしくは利用権を取得、増殖、改変もしくは利用し、またはその利用履歴、保有状況、利用期間もしくは取引状態等の記録を不正に改ざんしてはなりません。',
            '１２　当社は、事業上または運営上の必要に応じて、有料サービスの種類、名称、内容、特典、料金、提供方法その他の条件を変更し、またはその全部もしくは一部の提供を中断もしくは終了することがあります。購入済みの有料サービスの取扱いは、法令および購入時に表示された条件に従います。'
          ]
        },
        {
          title: '第9条（利用停止、アカウント停止および契約解除）',
          paragraphs: [
            '１　当社は、ユーザーが次の各号のいずれかに該当し、または該当するおそれがあると合理的に判断した場合、事前の通知または催告なく、本サービスの全部もしくは一部の利用を制限し、またはアカウントを停止することができます。当該事由が重大であり、本サービスの利用継続が困難であると合理的に判断した場合には、本サービスの利用に関する契約を解除することができます。',
            '（１）本規約または個別規定に違反した場合',
            '（２）登録情報に虚偽、誤記または記載漏れがあった場合',
            '（３）支払停止、支払不能その他信用状態に重大な不安が生じた場合',
            '（４）反社会的勢力に該当し、またはこれと密接な関係を有すると認められる場合',
            '（５）その他、当社が本サービスの利用継続を不適当と合理的に判断した場合',
            '２　ユーザーの責めに帰すべき事由により前項の措置を講じた場合、当社は、法令上必要な場合を除き、既に支払われた料金の返金、利用期間の延長その他の補償を行いません。',
            '３　本条に基づく措置に関する当社の責任は、第11条の定めによります。'
          ]
        },
        {
          title: '第10条（サービス内容の変更、中断および終了）',
          paragraphs: [
            '１　当社は、法令の変更、技術上もしくは運営上の必要性、セキュリティの確保、第三者サービスの変更もしくは終了その他合理的な必要がある場合、本サービスの内容を変更し、その全部もしくは一部の提供を中断し、または終了することがあります。',
            '２　当社は、保守点検、システムもしくは通信回線の障害、第三者サービスの停止、災害、停電、不可抗力、緊急のセキュリティ対応その他やむを得ない事由がある場合、事前の通知なく本サービスの全部または一部を一時的に中断することがあります。',
            '３　本サービスの変更、中断または終了について法令上周知または通知が必要となる場合、当社は、当該法令に従って必要な周知または通知を行います。それ以外の場合、当社は、当社が適切と判断する時期および方法により周知または通知することがあります。',
            '４　本条に基づく変更、中断または終了に関する当社の責任は、第11条の定めによります。有料サービスの料金その他の取扱いは、法令および購入時に表示された条件に従います。'
          ]
        },
        {
          title: '第11条（免責および責任の制限）',
          paragraphs: [
            '１　当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定目的適合性、継続性、セキュリティ等に関する欠陥、エラー、バグ、権利侵害等を含みますが、これらに限られません。）がないことを保証するものではありません。ただし、本項は、本サービスに関して当社が負う債務の不履行または不法行為に基づく損害賠償責任を免除するものではなく、当該責任の範囲は次項以下の定めによります。',
            '２　当社の軽過失によりユーザーに損害が生じた場合、当社は、直接かつ通常生ずべき損害に限り責任を負い、特別損害、間接損害および逸失利益について責任を負いません。',
            '３　前項の場合、当社の損害賠償責任の総額は、損害発生時点から遡って過去12か月間にユーザーが当社または当社の指定する販売事業者に支払った本製品の代金および有料サービスの対価の総額を上限とします。',
            '４　前2項の定めは、当社、その代表者またはその使用する者に故意もしくは重大な過失がある場合、当社の責めに帰すべき事由によりユーザーの生命または身体に損害が生じた場合その他法令上責任を制限することができない場合には、適用されません。'
          ]
        },
        {
          title: '第12条（反社会的勢力の排除）',
          paragraphs: [
            '１　ユーザーは、自らが反社会的勢力に該当せず、かつ反社会的勢力と密接な関係を有しないことを表明し、保証するものとします。',
            '２　ユーザーが前項に違反した場合、当社は、何らの催告を要することなく、直ちに本サービスの利用停止、アカウント停止または契約解除を行うことができます。'
          ]
        },
        {
          title: '第13条（規約の変更）',
          paragraphs: [
            '１　当社は、次の各号のいずれかに該当する場合、民法第548条の4の規定に基づき、本規約を変更することがあります。',
            '（１）変更がユーザーの一般の利益に適合するとき',
            '（２）変更が本規約に基づく契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他変更に係る事情に照らして合理的なものであるとき',
            '２　当社は、前項に基づき本規約を変更する場合、変更の効力発生日を定め、本規約を変更する旨、変更後の内容および効力発生日を、当該効力発生日までに、当社ウェブサイト、アプリ内表示その他適切な方法により周知します。'
          ]
        },
        {
          title: '第14条（退会およびアカウント削除）',
          paragraphs: [
            '１　ユーザーは、当社所定の方法により、いつでも本サービスを退会し、アカウントの削除を申請することができます。',
            '２　アプリケーションの削除、アカウントの削除または本製品とアカウントの連携解除のみでは、第三者プラットフォームを通じて購入した有料サービスの自動更新が停止されない場合があります。ユーザーは、購入時の表示または当該プラットフォームが定める方法により、別途自動更新の停止手続を行うものとします。',
            '３　アカウント削除後は、当該アカウントを通じて会話履歴、記憶データ、設定その他のデータを利用できなくなり、これらを復旧できない場合があります。データの削除その他の取扱いについては、プライバシーポリシーに従います。'
          ]
        },
        {
          title: '第15条（通知または連絡）',
          paragraphs: [
            '１　当社からユーザーへの通知または連絡は、アプリ内表示、電子メール、ウェブサイト上の掲載その他当社が適当と判断する方法により行います。',
            '２　ユーザーは、登録情報に変更があった場合には、速やかに当社所定の方法により変更手続を行うものとします。'
          ]
        },
        {
          title: '第16条（権利義務の譲渡禁止）',
          paragraphs: [
            '１　ユーザーは、当社の事前の書面または電磁的方法による承諾なく、本規約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、移転し、担保に供し、またはその他の処分をしてはならないものとします。',
            '２　当社は、本サービスに係る事業の全部または一部を第三者に譲渡した場合（合併、会社分割その他事業が移転する一切の場合を含みます。）、法令に従い、当該事業譲渡に伴って、本規約上の地位、本規約に基づく権利義務ならびに登録情報その他本サービスに関する情報を当該譲受人に承継させることができ、ユーザーはあらかじめこれに同意するものとします。'
          ]
        },
        {
          title: '第17条（存続）',
          paragraphs: [
            '１　本規約の終了後も、第4条第1項および第4項、第5条、第6条、第11条、第12条、第16条、第18条から第20条までならびにその性質上本規約の終了後も存続すべき規定は、引き続き有効に存続します。'
          ]
        },
        {
          title: '第18条（分離可能性）',
          paragraphs: [
            '１　本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約のその他の条項および当該条項の残りの部分は、引き続き効力を有するものとします。'
          ]
        },
        {
          title: '第19条（準拠法および裁判管轄）',
          paragraphs: [
            '１　本規約の解釈および適用にあたっては、日本法を準拠法とします。',
            '２　本サービスに関してユーザーと当社との間で紛争が生じた場合、法令上認められる範囲で、東京地方裁判所または東京簡易裁判所を第一審の合意管轄裁判所とします。'
          ]
        },
        {
          title: '第20条（事業者情報および問い合わせ窓口）',
          paragraphs: [
            '１　事業者名：株式会社Fuzozo',
            '所在地：〒150-0041 東京都渋谷区神南1-23-14 リージャス渋谷公園通りビル4F',
            '連絡先：info{\'@\'}fuzozo.jp',
            '２　本製品および有料サービスの販売に関する特定商取引法に基づく表示は、当社ウェブサイトその他購入前に表示するページに掲載します。',
            '以上'
          ]
        }
      ]
    }
  },
  'zh-TW': {
    userAgreement: {
      title: '使用者服務協議',
      updated: '最後更新：2026-01-20',
      intro: '歡迎使用 Fuzozo。使用本應用程式即表示您同意以下條款。',
      sections: [
        { title: '1. 應用程式使用', paragraphs: ['您僅可將本應用程式用於個人且合法的用途。', '您同意不會濫用本應用程式，也不會嘗試干擾其正常運作。'] },
        { title: '2. 帳號', paragraphs: ['您有責任妥善維護帳號安全。', '您可以隨時在應用程式內登出或刪除帳號。'] },
        { title: '3. 帳號終止', paragraphs: ['對於違反本協議的帳號，我們保留暫停或終止服務的權利。'] },
        { title: '4. 免責聲明', paragraphs: ['本應用程式按「現況」提供，不附帶任何形式的保證。', '我們不保證服務不會中斷或完全無錯。'] },
        { title: '5. 條款變更', paragraphs: ['我們可能會不定期更新本協議。', '繼續使用本應用程式即表示您接受更新後的條款。'] },
        { title: '6. 聯絡我們', paragraphs: ['如有任何問題，請聯絡：', 'support{\'@\'}fuzozo.net'], email: 'support{\'@\'}fuzozo.net' }
      ]
    }
  }
}
